import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { DrawerType, VerticalTransition } from "../../constants/index.js";
import { useClickOutside, useNoScroll } from "../../hooks/index.js";
import SettingsActionCreators from "../../redux/action-creators/settingsActionCreators.js";
import { SettingsSelectors } from "../../redux/selectors/index.js";
import userContextSelectors from "../../redux/selectors/userContextSelectors.js";
import { TrackingUtils } from "../../utils/index.js";
import { SettingsDrawerArea } from "../Settings/index.js";
import { SettingsDrawerHeader } from "../Settings/components/index.js";
import GenericDrawer from "./GenericDrawer.js";

const SettingsDrawer = () => {
  const isDrawerActive = useSelector(SettingsSelectors.general.isDrawerActive);
  const isDrawerLoaded = useSelector(SettingsSelectors.general.isDrawerLoaded);
  const isMobile = useSelector(userContextSelectors.isMobile);

  const dispatch = useDispatch();

  const drawerRef = useClickOutside(
    () => {
      TrackingUtils.sendAnalytics({
        dataCategory: "client overlay",
        dataAction: "click",
        dataLabel: `uc-settings-${isMobile ? "mobile" : "pc"}-close`
      });

      dispatch(SettingsActionCreators.general.toggleDrawer());
    },
    {
      disabled: !isDrawerActive,
      ignoreClass: ["debug-action-button", "ignore-uc-settings-pc"] //to do
    }
  );

  useNoScroll("settingsDrawer", isDrawerActive);

  return (
    <GenericDrawer
      componentRef={drawerRef}
      menu={DrawerType.SettingsArea}
      header={<SettingsDrawerHeader />}
      className="settings-drawer"
      isVisible={isDrawerActive && isDrawerLoaded}
      verticalTransition={
        isMobile ? VerticalTransition.Left : VerticalTransition.Right
      }
    >
      <SettingsDrawerArea />
    </GenericDrawer>
  );
};

export default React.memo(SettingsDrawer);
